module.exports = __webpack_public_path__ + "img/icon--arrow-down.b3791f64.svg";